// Vehicle Select Actions
import { gmiRequest } from "actions/request";
import { actions } from "@ehi/global-marketing-interface";

const {
    carClassState,
    selectCarClass: gmiSelectCarClass,
} = actions.reservations;

export const selectCarClass =
    ({ code, bundle_code, prepay = false, redirect = true }) =>
        (dispatch) => {
            dispatch(carClassState.set('code', { code }));
            if (bundle_code) {
                dispatch(carClassState.set('bundle_code', { bundle_code }));
            }
            dispatch(carClassState.set('prepay_selected', { prepay_selected: prepay }));
            return dispatch(
                gmiRequest({
                    action: gmiSelectCarClass(),
                    loadingOverlay: true,
                    redirect,
                })
            );
        };